import vue from 'vue';

vue.filter('lowercase', value => value.toLowerCase());



// WEBPACK FOOTER //
// ./src/filters/lowercase.filter.js